var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-sidebar",attrs:{"id":"iq-sidebar"}},[_c('div',{attrs:{"id":"sidebar-scrollbar"}},[_c('nav',{staticClass:"iq-sidebar-menu"},[_c('CollapseMenu',{attrs:{"items":_vm.sidebarMenus,"sidebar-group-title":true,"open":true}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }